import type {
	AiCreditsIncentiveId,
	AiCreditsIncentiveItem,
} from '../models/ai-credits-incentive.model';

/**
 * Customer-facing snackbar copy after a successful incentive submit
 * (verified or pending). Credits are taken from the incentive definition.
 */
export function buildAiCreditsIncentiveSuccessMessage(
	incentive: Pick<AiCreditsIncentiveItem, 'id' | 'monthlyCredits'>
): string {
	const credits = incentive.monthlyCredits.toLocaleString();
	return successMessageForId(incentive.id, credits);
}

function successMessageForId(
	id: AiCreditsIncentiveId,
	credits: string
): string {
	switch (id) {
		case 'g2-review':
			return `G2 review submitted successfully. You'll earn ${credits} AI credits now, and ${credits} more every month.`;
		case 'link-back':
			return `Link submitted successfully. You'll earn ${credits} AI credits now, and ${credits} more every month.`;
	}
}
